/**
 * Las monedas que el backend acepta para el presupuesto de una línea de control.
 *
 * Espeja `currency/utils.py` (`CURRENCIES.CURRENCIES`), que es lo que validan tanto el alta a mano
 * como el `add-bulk` del túnel: la lista de opciones sale de la misma fuente que las autoriza.
 *
 * Vive en su propio módulo, y no como estático de `CurrencySelect`, porque ese componente importa
 * `i18n` y con él levanta la inicialización entera de i18next. Quien sólo necesita los códigos
 * —el paso 4 del túnel, que pinta su propio selector con el estilo del recorrido— no tiene por qué
 * arrastrar eso.
 *
 * Sin repetidos a propósito: la lista original traía `GBP` dos veces (el backend también), lo que
 * pintaba una opción duplicada y dos claves de React iguales.
 */
export const CURRENCY_CODES = ["ARS", "USD", "CLP", "MXN", "PYG", "BRL", "EUR", "UYU", "GBP", "PEN",
                               "COP", "CRC", "AUD", "ILS", "SEK", "NOK", "DKK", "ISK", "CHF", "JPY",
                               "CNY"];
